// extracted by mini-css-extract-plugin
export default {"container":"ValidityPeriodItem_container__7PdB7","error":"ValidityPeriodItem_error__Zl9V5"};